import type { PropsWithChildren } from 'react';
import React from 'react';

import type { WithClassNameProp } from '@vlabs/uikit/types';
import classNames from 'classnames';

import st from './ResultItem.module.sass';

export interface ResultItemProps extends
  PropsWithChildren,
  WithClassNameProp {
  label: string;
}

export function ResultItem({
  label,
  children,
  className = undefined,
}: ResultItemProps): React.JSX.Element {
  return (
    <div className={classNames(st.Root, className)}>
      <div className={st.Label}>{label}</div>
      <div className={st.Value}>
        {children}
      </div>
    </div>
  );
}
